var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "order" }, [
    _c("div", { staticClass: "head" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "head_con" }, [
        _c("p", { staticClass: "con_address" }, [
          _vm._v(_vm._s(_vm.adress.addressDesc))
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "con_name" }, [
          _vm._v(
            "\n        " +
              _vm._s(_vm.adress.contactName) +
              " " +
              _vm._s(_vm.adress.contactPhone) +
              "\n      "
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "goods_list" },
      [
        _c("div", { staticClass: "list_title" }, [
          _vm._v("\n      商品信息\n    ")
        ]),
        _vm._v(" "),
        _vm._l(_vm.list, function(item, index) {
          return _c("div", { key: index, staticClass: "list_item" }, [
            _c("div", { staticClass: "item_img" }, [
              _c("img", {
                attrs: {
                  src: item.goodsImageUrl
                    ? item.goodsImageUrl
                    : "../../static/image/bgimg.png"
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "item_center" }, [
              _c("p", { staticClass: "center_tit" }, [
                _vm._v(_vm._s(item.goodsName))
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "center_price" }, [
                _vm._v("\n          ￥" + _vm._s(item.goodsPrice) + " "),
                _c("span", [_vm._v("x" + _vm._s(item.goodsNumber))])
              ])
            ])
          ])
        })
      ],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "distribution" }, [
      _c("p", { staticClass: "distribution_tit" }, [_vm._v("配送费")]),
      _vm._v(" "),
      _c("p", { staticClass: "distribution_content" }, [
        _vm._v("￥" + _vm._s(_vm.saleTempInfo.deliveryCost || 0))
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "distribution" }, [
      _c("p", { staticClass: "distribution_tit" }, [_vm._v("配送说明")]),
      _vm._v(" "),
      _c("p", { staticClass: "distribution_content" }, [
        _vm._v(_vm._s(_vm.saleTempInfo.deliveryDesc))
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "distribution" }, [
      _c("p", { staticClass: "distribution_tit" }, [_vm._v("合计")]),
      _vm._v(" "),
      _c("p", { staticClass: "distribution_totle" }, [
        _vm._v("￥" + _vm._s(_vm.saleTempInfo.amount))
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "distribution" }, [
      _c("p", { staticClass: "distribution_tit" }),
      _vm._v(" "),
      _c(
        "a",
        { staticClass: "callShop", attrs: { href: "tel:" + _vm.shopData.tel } },
        [_vm._v("联系商家")]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "head_img" }, [
      _c("img", { attrs: { src: require("../../static/image/positions.png") } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-746c7079", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-746c7079","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/orderDetail/index.vue
// module id = null
// module chunks = 